import { buildResultTemplatesManager } from '@coveo/headless';
import React from 'react';
import { InteractiveResult } from '../components/interactive-result';
import { headlessEngine } from '../engine';

const { dataset } = document.getElementsByClassName(
  'coveo-search-results__main-wrapper'
)[0];

// this function is used to convert unicode to string
function covertUnicode(str) {
  if (typeof str === 'string') {
    return str.replace(/\\u[\dA-F]{4}/gi, match =>
      String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16))
    );
  }
  return str;
}

export const resultTemplatesManager =
  buildResultTemplatesManager(headlessEngine);

resultTemplatesManager.registerTemplates({
  conditions: [],
  fields: ['title', 'excerpt', 'uniqueId'],
  content: result => (
    <li key={result.uniqueId} className="system-list__system">
      <InteractiveResult result={result} className="system-list__system-anchor">
        <div className="system-list__img-wrapper">
          <img
            alt={result.raw.systemdetailthumbnailalt}
            className="system-list__system-img"
            src={result.raw.systemdetailthumbnail}
          ></img>
        </div>
        <p className="link-siplast link">{result.raw.systemdetailname}</p>
      </InteractiveResult>
    </li>
  )
});
